import Axios from 'axios'

export default {
  namespaced: true,
  state: {
    groupArr: null,
    inviteArr: null,
    inviteTransactResponse: null,
    changePasswordResponse: null,
    saveEditedProfile: null,
    usernameAvailability: null
  },
  getters: {
    INVITE_ARR: state => state.inviteArr,
    GROUP_ARR: state => state.groupArr,
    INVITE_TRANSACT_RESPONSE: state => state.inviteTransactResponse,
    CHANGE_PASSWORD_RESPONSE: state => state.changePasswordResponse,
    SAVE_EDITED_PROFILE_RESPONSE: state => state.saveEditedProfile,
    USERNAME_AVAILABILITY_RESPONSE: state => state.usernameAvailability
  },
  mutations: {
    SET_GROUP_ARR: (state, payload) => {
      state.groupArr = payload
    },
    SET_INVITE_ARR: (state, payload) => {
      state.inviteArr = payload
    },
    SET_INVITE_TRANSACT_RESPONSE: (state, payload) => {
      state.inviteTransactResponse = payload
    },
    SET_CHANGE_PASSWORD_RESPONSE: (state, payload) => {
      state.changePasswordResponse = payload
    },
    SET_SAVE_EDITED_PROFILE_RESPONSE: (state, payload) => {
      state.saveEditedProfile = payload
    },
    SET_USERNAME_AVAILABILITY_RESPONSE: (state, payload) => {
      state.usernameAvailability = payload
    }
  },
  actions: {
    FETCH_MYINVITE: async context => {
      try {
        const response = await Axios.get('/group/invite')
        context.commit('SET_INVITE_ARR', response.data)
      } catch (error) {
        context.commit('SET_INVITE_ARR', error.response.data)
      }
    },
    FETCH_MYGROUP: async context => {
      try {
        const response = await Axios.get('/group')
        context.commit('SET_GROUP_ARR', response.data)
      } catch (error) {
        context.commit('SET_GROUP_ARR', error.response.data)
      }
    },
    TRANSACT_INVITE: async (context, payload) => {
      try {
        const response = await Axios.post('/group/invite/transact', payload)
        context.commit('SET_INVITE_TRANSACT_RESPONSE', response.data)
      } catch (error) {
        context.commit('SET_INVITE_TRANSACT_RESPONSE', error.response.data)
      }
    },
    CHANGE_PASSWORD: async (context, payload) => {
      try {
        const response = await Axios.put('/user/change-password', payload)
        context.commit('SET_CHANGE_PASSWORD_RESPONSE', response.data)
      } catch (error) {
        context.commit('SET_CHANGE_PASSWORD_RESPONSE', error.response.data)
      }
    },
    SAVE_EDITED_PROFILE: async (context, payload) => {
      try {
        const response = await Axios.post(
          '/user/edit',
          payload.data,
          payload.config
        )
        context.commit('SET_SAVE_EDITED_PROFILE_RESPONSE', response.data)
        context.commit('auth/SET_USER', response.data.data, { root: true })
      } catch (error) {
        context.commit('SET_SAVE_EDITED_PROFILE_RESPONSE', error.response.data)
      }
    },
    USERNAME_AVAILABILITY: async (context, payload) => {
      try {
        const response = await Axios.post(
          '/user/edit-profile/check-username',
          payload
        )
        context.commit('SET_USERNAME_AVAILABILITY_RESPONSE', response.data)
      } catch (error) {
        context.commit(
          'SET_USERNAME_AVAILABILITY_RESPONSE',
          error.response.data
        )
      }
    }
  }
}
